<template>
  <div>
    <HomeHeaderNavBar></HomeHeaderNavBar>
    <CaseHeader></CaseHeader>
    <el-row style="margin-top: 20px;">
      <el-col
        :span="3"
        :offset="3"
      >
        <CaseMenu @getInfo="getInfo"></CaseMenu>
      </el-col>
      <el-col
        :span="14"
        :offset="1"
      >
        <CaseContent :formData="formData"></CaseContent>
      </el-col>
    </el-row>
    <HomeFooter></HomeFooter>
    <!-- <Fixed></Fixed> -->
  </div>
</template>

<script>
import HomeHeaderNavBar from "../home/components/HeaderNavBar";
import CaseMenu from "./components/CaseMenu";
import CaseHeader from "./components/CaseHeader";
import CaseContent from "./components/CaseContent";
import HomeFooter from "../home/components/Footer";
import Fixed from "@/pages/fixed";
import { message } from "@/assets/language/home/Zh-cn.js";

export default {
  name: "Solution",
  components: {
    HomeHeaderNavBar,
    CaseMenu,
    CaseHeader,
    CaseContent,

    HomeFooter,
    Fixed,
  },
  data() {
    return {
      formData: {},
      dataList: [],
    };
  },
  mounted() {
    this.getInfo(0);
  },
  methods: {
    getData() {},
    getInfo(val) {
      // this.formData.infoSrc = "@/assets/images/solution_hardware.png";
      // this.formData.index = val;

      this.formData = message.caseInfoList[val];
      // this.formData = this.dataList[val];
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/case/Case.vue